import { postPrefs } from '@user/store/dashboard/widgets/closedWonQueueSubmissions/api'
import { useGetCWQSPrefsOnMount } from '@user/store/dashboard/widgets/closedWonQueueSubmissions/hooks/useGetCWQSPrefsOnMount'
import {
  flipCard,
  selectClosedWonQueueSubmissionsSettings,
  setNumberOfdays,
} from '@user/store/dashboard/widgets/closedWonQueueSubmissions/slice'
import { useAppDispatch } from '@user/store/hooks'
import { Formik, FormikHelpers } from 'formik'
import * as React from 'react'
import { useSelector } from 'react-redux'
import { toast } from '@sales-center/components'
import { SettingsForm } from './SettingsForm'

export interface FormValues {
  numberOfDays: number
}

export function ContentBack() {
  const dispatch = useAppDispatch()
  useGetCWQSPrefsOnMount()
  const widgetData = useSelector(selectClosedWonQueueSubmissionsSettings)

  return (
    <Formik
      initialValues={{
        numberOfDays: widgetData.numberOfDays || 30,
      }}
      onSubmit={async (
        values: FormValues,
        { setSubmitting }: FormikHelpers<FormValues>,
      ) => {
        setSubmitting(true)

        dispatch(setNumberOfdays(values.numberOfDays))

        await dispatch(
          postPrefs({
            type: 'CWQS',
            numberOfDays: values.numberOfDays,
          }),
        )

        toast.success('Settings updated.')

        setSubmitting(false)
        dispatch(flipCard())
      }}
    >
      <SettingsForm />
    </Formik>
  )
}
